import * as tslib_1 from "tslib";
import { lazyGetSharePointItemsViewCurrentPath } from 'owa-group-fileshub-actions';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { lazyGetSxSStoreViewState } from 'owa-group-files-hub-store';
import { PreviewPaneMode } from 'owa-sxsdata';
import { lazyGroupHeaderCommandBarStore, lazyGroupHeaderNavigationButton, } from 'owa-group-header-actions';
import { composeStore } from 'owa-mail-compose-store';
import { getSelectedNode } from 'owa-mail-folder-forest-store';
import { readingPaneStore } from 'owa-mail-reading-pane-store';
import getSelectedFolder from 'owa-mail-store/lib/utils/getSelectedFolder';
import { getCurrentOptionRoute } from 'owa-options-router';
import { previewPaneStore } from 'owa-preview-pane-store';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { sxsStore } from 'owa-sxs-store';
export default function getCurrentRoute() {
    var e_1, _a;
    var route = [];
    var optionRoute = getCurrentOptionRoute();
    if (optionRoute.length) {
        return optionRoute;
    }
    if (composeStore.defaultViewState) {
        route.push('compose');
        if (composeStore.defaultViewState.itemId && composeStore.defaultViewState.itemId.Id) {
            route.push(composeStore.defaultViewState.itemId.Id);
        }
        return route;
    }
    var selectedNode = getSelectedNode();
    if (selectedNode.type === 1 /* Persona */) {
        route.push('persons');
        route.push(selectedNode.id);
        return route;
    }
    else if (selectedNode.type === 5 /* PrivateDistributionList */ &&
        isControlFeatureEnabled('peo-favoritePdls')) {
        route.push('contactlists');
        route.push(selectedNode.id);
        return route;
    }
    else if (selectedNode.type === 4 /* Category */ &&
        isControlFeatureEnabled('tri-categories-advanced')) {
        route.push('category');
        route.push(selectedNode.id);
        return route;
    }
    else if (selectedNode.type === 2 /* Group */) {
        if (selectedNode.id) {
            var emailAddressParts = selectedNode.id.split('@');
            if (emailAddressParts.length != 2) {
                return route;
            }
            route.push('group');
            route.push(emailAddressParts[1]); // Domain part
            route.push(emailAddressParts[0]); // alias part
            var groupHeaderCommandBarStore = lazyGroupHeaderCommandBarStore.tryImportSync();
            var groupHeaderNavigationButton = lazyGroupHeaderNavigationButton.tryImportSync();
            if (groupHeaderCommandBarStore && groupHeaderNavigationButton) {
                switch (groupHeaderCommandBarStore.navigationButtonSelected) {
                    case groupHeaderNavigationButton.Email:
                        route.push('email');
                        break;
                    case groupHeaderNavigationButton.Files:
                        route.push('files');
                        var getGroupSxSStoreViewState = lazyGetSxSStoreViewState.tryImportSync();
                        // SP file preview
                        if (getGroupSxSStoreViewState) {
                            var groupSxSStoreViewState = getGroupSxSStoreViewState();
                            if (groupSxSStoreViewState &&
                                groupSxSStoreViewState.previewPane &&
                                groupSxSStoreViewState.previewPane.mode != PreviewPaneMode.Blank) {
                                // Preview a SharePoint file using the new SxS
                                route.push('sxs');
                                route.push('sp');
                                route.push(groupSxSStoreViewState.previewPane.id);
                                break;
                            }
                        }
                        // attachment preview
                        if (sxsStore.extendedViewState.attachmentId) {
                            // The sxsStore.extendedViewState will never be null
                            route.push('sxs');
                            route.push('attachment');
                            route.push(sxsStore.extendedViewState.attachmentId.Id);
                            break;
                        }
                        // Items view navigation
                        var getSharePointItemsViewCurrentPath = lazyGetSharePointItemsViewCurrentPath.tryImportSync();
                        if (getSharePointItemsViewCurrentPath) {
                            var path = getSharePointItemsViewCurrentPath(selectedNode.id);
                            if (path && path.length > 0) {
                                if (path.charAt(0) == '/') {
                                    path = path.substring(1);
                                }
                                var parts = path.split('/');
                                try {
                                    for (var parts_1 = tslib_1.__values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
                                        var p = parts_1_1.value;
                                        route.push(p);
                                    }
                                }
                                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                finally {
                                    try {
                                        if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
                                    }
                                    finally { if (e_1) throw e_1.error; }
                                }
                            }
                        }
                        break;
                }
            }
            return route;
        }
    }
    else {
        var selectedFolder = getSelectedFolder();
        if (selectedFolder) {
            // We push a friendly name if it is a distinguished folder (ex: inbox, junkemail, etc.),
            // otherwise we push its folder id.
            var selectedFolderId = selectedFolder.FolderId.Id;
            route.push(selectedFolder.distinguishedFolderId
                ? folderIdToName(selectedFolderId)
                : selectedFolderId);
        }
    }
    if (readingPaneStore.conversationReadingPaneViewState) {
        route.push('id');
        route.push(readingPaneStore.conversationReadingPaneViewState.conversationId.Id);
    }
    else if (readingPaneStore.itemReadingPaneViewState) {
        route.push('id');
        route.push(readingPaneStore.itemReadingPaneViewState.itemId);
    }
    else {
        // No-op
    }
    if (isAttachmentFeatureEnabled('doc-SxS-refactor')) {
        if (sxsStore.extendedViewState.attachmentId) {
            route.push('sxs');
            route.push(sxsStore.extendedViewState.attachmentId.Id);
        }
    }
    else {
        if (previewPaneStore.state &&
            previewPaneStore.state.itemId &&
            previewPaneStore.state.attachmentId) {
            route.push('sxs');
            route.push(previewPaneStore.state.itemId.Id);
            route.push(previewPaneStore.state.attachmentId.Id);
        }
    }
    return route;
}
//# sourceMappingURL=getCurrentRoute.js.map